<script setup lang="ts">
// PROPS
type ItemSpace = '3' | '5';

type ListStyle = { type: 'index' } | { type: 'icon'; name: string };

type BlockListItem =
    | string
    | {
          title: string;
          description: string;
      };

interface Props {
    title?: string;
    description?: string;
    items?: BlockListItem[];
    space?: ItemSpace;
    listStyle?: ListStyle;
}

const { space = '3', items = [], listStyle = { type: 'index' } } = defineProps<Props>();

// DATA
const itemSpace = computed(() => (space === '3' ? 'space-y-3' : 'space-y-5'));
</script>

<template>
    <div class="flex flex-col gap-y-6">
        <h3 v-if="$slots.title || !!title" class="text-primary-800 text-3xl font-semibold">
            <slot name="title">{{ title }}</slot>
        </h3>
        <div v-if="$slots.description || !!description" class="text-base">
            <slot name="description">{{ description }}</slot>
        </div>
        <ul v-if="$slots.list || !!items" class="list-none text-base" :class="itemSpace">
            <li v-for="(item, index) in items" :key="index" class="flex items-center gap-4">
                <UIcon
                    v-if="listStyle.type === 'icon'"
                    class="size-4 shrink-0"
                    :name="listStyle.name"
                    :class="{ 'self-start': typeof item !== 'string' }"
                />
                <span v-else class="text-primary font-bold" :class="{ 'w-[1.875rem] self-start text-xl': typeof item !== 'string' }">
                    {{ formatBlockIndex(index + 1) }}
                </span>

                <template v-if="typeof item === 'string'">
                    <span class="font-medium">{{ item }}</span>
                </template>
                <template v-else>
                    <div class="flex flex-col gap-2">
                        <h4 class="text-xl font-semibold">{{ item.title }}</h4>
                        <p>{{ item.description }}</p>
                    </div>
                </template>
            </li>
        </ul>
    </div>
</template>
